import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { HeaderContainer, Title, SettingsMenu, SettingsIcon, HeaderRow, SettingsWrapper } from "./style";
import PageSettings from "../Settings/PageSettings";
import PageExpand from "../PageExpand/PageExpand";
import Logo from "../Logo";
import MenuIcon from "../MenuIcon";
import LanguageChanger from "../LanguageChanger";
import { LanguageConfig } from "../../languages";

const Header = ({
                    title,
                    disableSettings,
                    multipleScreensStart,
                    progressBar,
                    overrideSettings
                }) => {
    const [openSettings, setOpenSettings] = useState(false);

    const toggleGeneralSettingsPopup = (generalSettings) => {
        if (!generalSettings) {
            setOpenSettings(false);
        }
    };

    const openSettingsMenu = () => {
        setOpenSettings(!openSettings);
    };

    const stopPropogation = (event) => {
        event.stopPropagation();
        event.nativeEvent.stopImmediatePropagation();
    };

    const handleOutsideClick = () => {
        setOpenSettings(false);
    };

    useEffect(() => {
        document.addEventListener("click", handleOutsideClick);
        return () => {
            document.removeEventListener("click", handleOutsideClick);
        };
    }, []);

    useEffect(() => {
        handleOutsideClick();
    }, [window.location.pathname]);

    return (
        <>
            <MenuIcon toggleGeneralSettingsPopup={toggleGeneralSettingsPopup} />
            <HeaderContainer>
                <Title>{title}</Title>
                {multipleScreensStart}
                <Logo position="center" />
                <HeaderRow>
                    {progressBar}
                    {/*
                    TODO: API 404 verdiği için kapatıldı. API hazırlandığında kodlar açılacak
                    <Date showClock={true} />*/}
                    {!disableSettings && (
                        <SettingsWrapper onClick={(e) => stopPropogation(e)}>
                            <SettingsIcon onClick={() => openSettingsMenu()} openSettings={openSettings} />
                            {!disableSettings && openSettings && (
                                <SettingsMenu>
                                    <PageSettings {...overrideSettings} />
                                </SettingsMenu>
                            )}
                        </SettingsWrapper>
                    )}
                    <PageExpand />
                    {LanguageConfig?.isSelectable && <LanguageChanger />}
                </HeaderRow>
            </HeaderContainer>
        </>
    );
};

Header.propTypes = {
    title: PropTypes.string.isRequired,
    disableSettings: PropTypes.bool,
    multipleScreensStart: PropTypes.node,
    progressBar: PropTypes.node,
    pageName: PropTypes.string,
    overrideSettings: PropTypes.shape({
        goalEffect: PropTypes.bool,
        matchTimeRange: PropTypes.bool
    })
};

export default Header;
